var _style, _g, _path, _path2, _path3, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149 146.6",
    style: {
      enableBackground: "new 0 0 149 146.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6363;}\n\t.st1{fill:#F4F4FF;stroke:#F4F4FF;stroke-width:0.4;}\n\t.st2{fill:none;stroke:#F4F4FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,34.1C3,16.6,17.2,2.4,34.8,2.4h79.5c17.6,0,31.8,14.2,31.8,31.8v79.5c0,17.6-14.2,31.8-31.8,31.8H34.8 C17.2,145.4,3,131.2,3,113.6V34.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,73.3c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c12.3,0,13,0.3,20.6,4.1c1.5,0.7,3.1,1.6,4.9,2.4l0,0 c0.2,0.1,0.5,0.2,0.7,0.2h15.7c0.7,0.2,1.3,0.7,1.6,1.1c0.3,0.5,0.5,1,0.6,1.5c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.6,0.8-1.1,1h-18 c-0.1,0-0.2,0-0.3,0c-0.6,0.1-4.9,0.9-5.4,5.1c-0.1,0.8,0.5,1.6,1.4,1.7c0.8,0.1,1.6-0.5,1.7-1.4c0.2-1.9,2.3-2.3,2.7-2.4h18.2 c0.2,0,0.4,0,0.6-0.1l-0.6-1.4l0.6,1.4c1.3-0.5,2.2-1.4,2.8-2.4c0.6-1,0.8-2.1,0.8-3.2c-0.1-1.1-0.5-2.2-1.2-3.1 c-0.7-1-1.8-1.8-3.3-2.2C88.7,80,88.5,80,88.3,80H72.7c-1.9-0.9-3.3-1.6-4.5-2.2C60,73.7,59.3,73.3,46.2,73.3L46.2,73.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,97.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5H53c28,10,30.9,8.3,47.2-1.6 c4.8-2.9,10.8-6.6,19.2-10.9l-0.7-1.3l0.7,1.4c0.2-0.1,0.3-0.2,0.4-0.3c1.7-1.5,2.3-3.4,2.3-5.1c0-1.1-0.3-2.1-0.9-3 c-0.5-0.9-1.3-1.6-2.1-2.2c-1.3-0.8-3-1-4.6-0.4l0.5,1.4l-0.5-1.4c-0.1,0-0.1,0.1-0.2,0.1L88.5,88.3c-0.8,0.3-1.1,1.2-0.8,2 c0.3,0.8,1.2,1.1,2,0.8L115.4,80c0,0,0,0,0.1,0l0,0c0.8-0.3,1.5-0.2,2.1,0.2c0.4,0.2,0.8,0.6,1,1.1c0.3,0.5,0.4,1,0.4,1.5 c0,0.9-0.3,1.9-1.2,2.7c-8.3,4.3-14.4,8-19.2,10.9c-15.2,9.3-17.9,10.9-44.7,1.3c-0.2-0.1-0.4-0.1-0.6-0.1L46.2,97.5L46.2,97.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,70.8v32.4c0,0.8-0.7,1.5-1.5,1.5H33.1c-0.8,0-1.5-0.7-1.5-1.5V70.8c0-0.8,0.7-1.5,1.5-1.5h12.8 C46.8,69.2,47.4,69.9,47.4,70.8z M44.4,101.6V72.3h-9.8v29.3H44.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 65.2,
    cy: 54.3,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 65.2,
    cy: 54.3,
    r: 9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 93.5,
    cy: 61.4,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 93.5,
    cy: 61.4,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDue);
export default __webpack_public_path__ + "static/media/payment_due.a045d275ddb1c7cebd1721722ef0a3ad.svg";
export { ForwardRef as ReactComponent };